import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/modules/shared.module';
import { UtilsModule } from '@app/modules/utils.module';
import { MaterialImports } from '@environments/environment';
import { FormsModule } from '@angular/forms';
import { LiveMatchComponent } from '@components/livematch.component';
import { MatchRowComponent } from '@components/match.row.component';
import { BetStopReasonModule } from '@components/betStopReason/betStopReason.module';
import { EventDetailsModule } from '@components/eventDetails/eventDetails.module';
import { OutrightsComponent } from '@components/outrights.component';
import { LiveEventDetailsModule } from '@components/eventDetails/LiveEventDetails.module';

@NgModule({
  declarations: [MatchRowComponent, OutrightsComponent],
  exports: [MatchRowComponent, OutrightsComponent],
  imports: [CommonModule, SharedModule, UtilsModule, RouterModule, MaterialImports, FormsModule, BetStopReasonModule, EventDetailsModule, LiveEventDetailsModule],
})
export class FixtureUtilsModule {}
